import React from 'react'
import { Box, Paper, TextField, MenuItem } from '@material-ui/core'
import { useStyles } from './style'

function SystemsOverview(props) {
  const classes = useStyles()
  const { dots } = props
  let dot = ''

  for (let i = 1; i <= dots; i++) {
    dot += '.'
  }

  const handleProgramNameChange = () => {

  }

  const handleDaysChange = () => {

  }

  return (
    <Box p={2}>
      {/* <div className={classes.summaryheaderWrapper}>Systems Enrolled Overview</div> */}
      <Box className={classes.summaryheaderWrapper} display="flex" p={1} flexWrap="wrap" alignItems="center">
        <Box p={1} flexGrow={1}>
          Systems Enrolled Overview
        </Box>
        <Box display="flex" flexWrap="wrap">
          <Box mr={1}>
            <TextField
              id="program"
              className={classes.selectbox}
              fullWidth
              select
              label="Select Program Name"
              onChange={handleProgramNameChange}
              InputProps={{
                classes: { root: classes.input }
              }}
              SelectProps={{
                MenuProps: {
                  classes: { paper: classes.paper },
                  anchorOrigin: {
                    vertical: "bottom",
                    horizontal: "left"
                  },
                  getContentAnchorEl: null
                }
              }}
            >
              <MenuItem value="connectedSolutions">connectedSolutions-NG-MA</MenuItem>
            </TextField>
          </Box>
          <Box >
            <TextField
              id="days"
              className={classes.selectbox}
              fullWidth
              select
              label="View Data of"
              onChange={handleDaysChange}
              InputProps={{
                classes: { root: classes.input }
              }}
              SelectProps={{
                MenuProps: {
                  classes: { paper: classes.paper },
                  anchorOrigin: {
                    vertical: "bottom",
                    horizontal: "left"
                  },
                  getContentAnchorEl: null
                }
              }}
            >
              <MenuItem value="14days">Last 14 Days</MenuItem>
            </TextField>
          </Box>
        </Box>
      </Box>
      <div className={`${classes.cardWrapper} ${classes.center}`}>
        <div className={classes.comingsoon}>COMING SOON {dot}</div>
      </div>
    </Box>
  )
}

export default SystemsOverview